import { Metamodel } from 'app/model/base/model';
import { Transformation, DataFlowStream } from 'app/model/dataflow/transformation';

@Metamodel.model({
    name: 'singlestreamoutputtransformation', // As this is abstract this will never be used
    abstract: true
})
export abstract class SingleStreamOutputTransformation extends Transformation {
    public get outputStream(): DataFlowStream {
        if (this.outputStreams.size > 1) {
            throw new Error(`${Metamodel.modelOf(this).name}/${this.name} transformation suppose to have only single output stream not multiple.`);
        }
        return this.outputStreams.values().next().value;
    }
}
